var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourcesHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#3474E0",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 5.33325H7.99984C7.64622 5.33325 7.30708 5.47373 7.05703 5.72378C6.80698 5.97382 6.6665 6.31296 6.6665 6.66659V17.3333C6.6665 17.6869 6.80698 18.026 7.05703 18.2761C7.30708 18.5261 7.64622 18.6666 7.99984 18.6666H15.9998C16.3535 18.6666 16.6926 18.5261 16.9426 18.2761C17.1927 18.026 17.3332 17.6869 17.3332 17.3333V9.33325M13.3332 5.33325L17.3332 9.33325M13.3332 5.33325L13.3332 9.33325H17.3332M14.6665 12.6666H9.33317M14.6665 15.3333H9.33317M10.6665 9.99992H9.33317",
    stroke: "#3474E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourcesHeader);
export default __webpack_public_path__ + "static/media/sources_header.3539aca4e48962dad4e50313ae39e1c6.svg";
export { ForwardRef as ReactComponent };